import React from 'react'
import useTranslation from '../../shared/TranslationProvider'
import { useExercise } from '../ExerciseProvider'
import { cn } from '../../../lib/utils'
import {
  FancyCheckBox,
  FancyCheckBoxComponent,
} from '../../shared/FancyCheckBox'
import { useDecisionMaking } from './DecisionMakingProvider'
import { ClearSelectionsButton } from '../../shared/Buttons'
import parse from 'html-react-parser'

const PartOne = () => {
  const { exerciseIndex } = useExercise()
  const { clearSelectedValues } = useDecisionMaking()
  const { t } = useTranslation('decision_making')
  const rankingValues = t(
    `pages.${exerciseIndex}.values-ranking`,
  ).ranking_values

  return (
    <>
      <h1>{t(`pages.${exerciseIndex}.values-ranking.title`)}</h1>
      {parse(t(`pages.${exerciseIndex}.values-ranking.body`))}
      <div className="questions flex flex-col pt-4">
        <div className="grid grid-cols-2 gap-4">
          {rankingValues.map((value, idx) => (
            <ChecklistItem
              item={value}
              key={`values-checklist-${idx}`}
              className={'col-span-2 md:col-span-1'}
            />
          ))}
        </div>
        <ClearSelectionsButton onClick={() => clearSelectedValues()}>
          {t(`pages.${exerciseIndex}.values-ranking.clear_selections`)}
        </ClearSelectionsButton>
      </div>
    </>
  )
}

const ChecklistItem = ({ item, className }) => {
  const { handleSelectValue, selectedValues } = useDecisionMaking()
  const disabled = selectedValues.length >= 8 && !selectedValues.includes(item)
  const selected = selectedValues.includes(item)

  const handleCheck = () => {
    if (disabled) {
      return
    }
    handleSelectValue(item)
  }

  return (
    <div className={cn('flex flex-col', className)}>
      <FancyCheckBoxComponent
        variant={selected ? 'selected' : disabled ? 'disabled' : 'unselected'}
        label={item}
      >
        <FancyCheckBox checked={selected} onCheckedChange={handleCheck} />
      </FancyCheckBoxComponent>
    </div>
  )
}

export default PartOne
